import { render, staticRenderFns } from "./Tvs.vue?vue&type=template&id=fa255132&scoped=true&"
import script from "./Tvs.vue?vue&type=script&lang=js&"
export * from "./Tvs.vue?vue&type=script&lang=js&"
import style0 from "./Tvs.vue?vue&type=style&index=0&id=fa255132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa255132",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa255132')) {
      api.createRecord('fa255132', component.options)
    } else {
      api.reload('fa255132', component.options)
    }
    module.hot.accept("./Tvs.vue?vue&type=template&id=fa255132&scoped=true&", function () {
      api.rerender('fa255132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tvs.vue"
export default component.exports